import * as React from "react";
import { ConnectAccountOnboarding, ConnectComponentsProvider } from "@stripe/react-connect-js";
import { loadConnectAndInitialize, StripeConnectInstance } from "@stripe/connect-js";
import { useState, useEffect } from "react";
import { useUser } from "@/src/store/user-store";
import { useCreateStripeOnboardingAccountMutation, useGetStripeOnboardingAccountDataMutation, useUpdateStripeOnboardingAccountMutation } from "@/src/mutations/stripeOnboarding/create-onboarding-account";
import { toast } from "sonner";
import { useToken } from "@/src/store/token-store";
import { useCreateStripeOnboardingSessionMutation } from "@/src/mutations/stripeOnboarding/create-onboarding-session";
import { useUserQuery } from "@/src/queries/user/user-details";


export function StripeConnectVerification({
    onSuccess,
    handleVerificationSuccess
  }: {
    onSuccess: () => void
    handleVerificationSuccess: () => void
  }) {
  const { user, _hasHydrated } = useUser();

  const [stripeConnectInstance, setStripeConnectInstance] = useState<StripeConnectInstance>();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [acctNo, setAcctNo] = useState<string>('');
  const [clientSecret, setClientSecret] = useState<string>('');
  const [userStripeData, setUserStripeData] = useState<{ payouts_enabled: boolean }>();
  const createStripeAccount = useCreateStripeOnboardingAccountMutation()
  const getAccountSession = useCreateStripeOnboardingSessionMutation()
  const updateStripeData = useUpdateStripeOnboardingAccountMutation()
  const getStripeUserData = useGetStripeOnboardingAccountDataMutation()
  const { refetch } = useUserQuery()
  useEffect(() => {
    if (_hasHydrated && user?.email && !user?.StripeAccountId && !acctNo && useToken.getState().accessToken) {
      const sendEmail = async () => {
       await createStripeAccount.mutate(
          {
            email: user?.email,
            country: user?.countryShortname
          },
          {
            onError: (error) => {
              toast.error(error.message)
            },
            onSuccess: async (e) => {
              console.log("stripe acct created")
             await updateStripeData.mutate(
                {
                  StripeAccountId: e.id,
                },
                {
                  onError: (error) => {
                    toast.error(error.message)
                  },
                  onSuccess: () => {
                    console.log("stripe acct updated")
                    setAcctNo(e.id)
                    refetch()
                  },
                }
              )
            },
          }
        )

      };
      sendEmail();
    } else if (_hasHydrated && user?.email && user?.StripeAccountId && !acctNo && useToken.getState().accessToken) {
      setAcctNo(user?.StripeAccountId)
    }
  }, [_hasHydrated, useToken.getState().accessToken])
  const fetchUserData = async () => {
    try {
      await getStripeUserData.mutate(
        {
          StripeAccountId: acctNo,
        },
        {
          onError: (error) => {
            return ''
          },
          onSuccess: (e) => {
            setUserStripeData(e)
          },
        }
      )
    } catch (error) {
      console.error('Error fetching client secret!', error);
      return ''
    }

  };
  useEffect(() => {
    if (acctNo) {
      //@ts-ignore
      const fetchClientSecret = async () => {
        try {
          await getAccountSession.mutate(
            {
              StripeAccountId: acctNo,
            },
            {
              onError: (error) => {
                return ''
              },
              onSuccess: (e: { client_secret: string }) => {
                setClientSecret(e.client_secret)

              },
            }
          )
        } catch (error) {
          console.error('Error fetching client secret!', error)
          return ''
        }

      };
      fetchClientSecret()
      fetchUserData()
    }

  }, [acctNo]);
  // console.log(user, "user", userStripeData)
  useEffect(() => {
    if (clientSecret) {
      const initializeStripe = async () => {
        try {
          const instance = await loadConnectAndInitialize({
            publishableKey: process.env.NEXT_PUBLIC_ENVIRONMENT === 'dev' ? 'pk_test_51NKf9WFYdHC8pZ3k25BtYpYoaUtjbmM3EocJ0DK2H0a0LgmCSi7ra4BbgGvkV9osn7gi6YIMNLDthqhTZNxFLYaD0064MBs6gx' : 'pk_live_51NKf9WFYdHC8pZ3kRBebNq58r5oENDZJR7SjG3fcN6yoz7uUaV1AEWqVckBr73MIdG1Xiw0woPdg1iJLw7r4Iv8O00TxmdENIK',
            fetchClientSecret: async () => { return await clientSecret },
            appearance: {
              variables: {
                colorPrimary: "#24BFA3",
                buttonPrimaryColorText: "#FFFFFF",
                fontFamily: "\"Plus Jakarta Sans\", sans-serif",
              },
            },
          });
          setStripeConnectInstance(instance);
        } catch (err) {
          console.error("Initialization error: ", err);
          setError("There was an issue initializing Stripe Connect.");
        } finally {
          setLoading(false);
        }
      };
      initializeStripe()
    }
  }, [clientSecret]);
  const onboardStripeUser = async()=>{
   await updateStripeData.mutate(
      {
        isOnboard: '1',
        StripeAccountId: user?.StripeAccountId,
      },
      {
        onError: (error) => {
          toast.error(error.message)
        },
        onSuccess: async () => {
         await refetch()
        },
      }
    )
  }
  useEffect(() => {
    if (userStripeData?.payouts_enabled === true && user?.stripeOnboard !== '1') {
      onboardStripeUser()
      handleVerificationSuccess()
    } else if (userStripeData?.payouts_enabled === true && user?.stripeOnboard === '1') {
      handleVerificationSuccess()
    }
  }, [userStripeData, user])

  if (loading) {
    return <div>Loading Stripe Connect...</div>
  }

  if (error || !stripeConnectInstance) {
    return <div>Error: {error}</div>
  }

  if (userStripeData && userStripeData?.payouts_enabled === true) {
    return <div>your details are submitted and verified successfully.

    </div>;
  }
  return (
    <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
      <ConnectAccountOnboarding
        onExit={() => {
          fetchUserData()
          console.log("The stripe account has exited onboarding");
          onSuccess()

        }}
        // fullTermsOfServiceUrl="{{URL}}"
        // recipientTermsOfServiceUrl="{{URL}}"
        // privacyPolicyUrl="{{URL}}"
        // skipTermsOfServiceCollection={false}
        collectionOptions={{
          fields: 'eventually_due',
          futureRequirements: 'include',
        }}
        onStepChange={(stepChange) => {
          console.log(`Stripe User entered: ${stepChange.step}`);
        }}
      />
    </ConnectComponentsProvider>)
}
export default StripeConnectVerification
